import React from 'react';
import "primereact/resources/themes/vela-orange/theme.css";
import "./App.css";
import { PrimeReactProvider } from 'primereact/api';
import MainMenu from './components/MainMenu';
import 'primeicons/primeicons.css';
import { Outlet } from "react-router-dom";
import useGoogleAnalytics from "./useGoogleAnalytics";
import { Panel } from 'primereact/panel';

export default function TemplateDemo() {
    useGoogleAnalytics("G-9C4KZJWBW8");
    return (
      <PrimeReactProvider>
          <div className="card">
              <MainMenu></MainMenu>
              <Panel><Outlet /></Panel>
          </div>
        </PrimeReactProvider>
    )
}